import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchProvisionalMergeCandidates } from "../api/titleService";
import { useDebouncedValue } from "./useDebouncedValue";
var SEARCH_DEBOUNCE_MS = 300;
var MIN_SEARCH_CHARS = 3;
export var useProvisionalMergeCandidates = function (provisionalId, searchQuery, type) {
    var kyInstance = useOkapiKy();
    var trimmed = searchQuery.trim();
    var debounced = useDebouncedValue(trimmed, SEARCH_DEBOUNCE_MS);
    var isDebouncePending = trimmed !== debounced;
    var enabled = !!provisionalId && debounced.length >= MIN_SEARCH_CHARS;
    var _a = useQuery(["provisionalMergeCandidates", provisionalId, debounced, type], function () {
        return fetchProvisionalMergeCandidates(kyInstance, provisionalId, debounced, type);
    }, {
        enabled: enabled,
        staleTime: 30000,
        select: function (response) { var _a; return (_a = response.items) !== null && _a !== void 0 ? _a : []; },
    }), _b = _a.data, candidates = _b === void 0 ? [] : _b, isLoading = _a.isLoading;
    return {
        candidates: candidates,
        isCandidatesLoading: enabled && (isLoading || isDebouncePending),
    };
};
